import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ICompany } from "src/app/interfaces/company";
import { ICompanyManager } from "src/app/interfaces/companyManager";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-add-manager-entry",
  templateUrl: "./add-manager-entry.component.html",
  styleUrls: ["./add-manager-entry.component.css"],
  providers: [ErrorsService]
})
export class AddManagerEntryComponent implements OnInit {
  form: FormGroup;
  hide: boolean = true;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private trnslate: TranslateService,
    private errorService: ErrorsService,
    private companyService: CompanyService,
    private dialogRef: MatDialogRef<AddManagerEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: ICompany
  ) {}

  showReciveCodeLink = true;

  ngOnInit() {
    this.form = this.fb.group({
      CompanyGuid: [this.data],
      NationalCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ],
      xActivateCode: [null]
    });
  }

  submitForm(form: ICompanyManager) {
    this.errors = new Array();
    this.companyService.addManger(form).subscribe(
      () => {
        this.showReciveCodeLink = false;
        if (form.xActivateCode) {
          this.companyService.saveManager(form).subscribe(() => {
            this.snackBar.OpenSnackBar(
              this.trnslate.get("success.registration"),
              "ok",
              5000,
              SoundEnum.beep
            );
            this.dialogRef.close();
          });
        }
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
  onNoclick() {
    this.dialogRef.close();
  }
}
